const styles = {
    errorBox: {
        "& .MuiCard-root": {
            backgroundColor: theme => theme.palette.critical[50],
            border: theme => `1px solid ${theme.palette.critical[100]}`,
            boxShadow: "unset",
            "& .error-content": theme => ({
                ...theme.typography.body4,
                color: theme.palette.greyscale[900],
                "& h4": {
                    ...theme.typography.body3,
                    display: "inline-block"
                }
            })
        },
        "& .MuiCardHeader-avatar": {
            "& svg": {
                fill: theme => theme.palette.critical[500],
                color: theme => theme.palette.critical[500]
            }
        }
    }
};
export default styles;
